import { Button } from '@chakra-ui/react'
import React from 'react'
import { FaFilePdf } from 'react-icons/fa'
import { usePdfGeneratorNew } from '../../../hooks/usePdfGenerator'

export const GerarPdf = ({ data }) => {
  const { generatePDF } = usePdfGeneratorNew()

  async function handleDownloadPdf() {
    const headData = [
      'Data Pedido',
      'Data NF-e',
      'Número Pedido',
      'Cliente',
      'NF-e',
      'Valor NF-e',
      'Pagamento',
      'Parcelas',
      'Valor Parcela',
      'Data Vencimento',
      'Data Pagamento',
      'Valor Real',
    ]
    const bodyData = data.map((item) => [
      item.data_pedido_liberado,
      item.data_nfe,
      item.numero_pedido,
      item.cliente,
      item.nfe,
      item.valor_nota,
      item.pagamento,
      item.parcelas,
      item.valor_parcela,
      item.data_vencimento,
      item.data_pagamento,
      item.valor_real,
    ])

    generatePDF(headData, bodyData, 'Relatório de Imposto')
  }

  return (
    <Button onClick={handleDownloadPdf} leftIcon={<FaFilePdf />} size="sm" colorScheme="red" maxW="120px" w="full">
      Gerar Pdf
    </Button>
  )
}
